import { keyBy } from '../lib';
import { getBackVersion } from '../config';
import { QuerySnapshot, ReportSnapshot } from '../models';
import api from './api';

type ReportResponse = Omit<ReportSnapshot, 'queries'> & {
    queries: QuerySnapshot[];
};

const toSnapshot = ({
    queries,
    ...response
}: ReportResponse): ReportSnapshot => {
    return { ...response, queries: keyBy(queries, x => x.id) };
};

const getReport = (reportId: number): Promise<ReportSnapshot> =>
    api
        .request<ReportResponse>({
            method: 'GET',
            url: `${getBackVersion()}/agent/reports/` + reportId,
        })
        .then(toSnapshot);

export default { getReport };
